import { api } from '../../services/api';

const ACTIVATIONS_URL = '/activations/';

export const getData = (filters) =>
  api.get(`${ACTIVATIONS_URL}?${filters}`);
